var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 254,
    viewBox: "0 0 252 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.896 176.175L48.9921 253.619L0.789062 205.701L78.693 128.256L0.789062 50.3271L48.9921 2.4082L126.896 80.337L175.099 128.256L126.896 176.175Z",
    fill: "#FF4654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.966 253.648L252 205.445L201.29 154.874L153.278 203.099L203.966 253.648Z",
    fill: "#0F1822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.918 52.1737L203.966 0.947266L252 49.1503L200.904 100.426L161.587 60.9355L161.545 60.893L152.918 52.1737Z",
    fill: "#0F1822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.961d5da6595471e8e9b5aed04243ce5e.svg";
export { ForwardRef as ReactComponent };